/*!
 *  (c)(r) 2008-2021 IT-Service Robert Frunzke
 */

import { clip } from './util.js';
import { jQuery } from '../other/jquery-hooked.js';


export function getPreferedMaxDialogWidth() {
	return clip( jQuery('#page-head').innerWidth(), 240, 4800 );
}

export function getPreferedMaxDialogHeight() {
	var mh = jQuery('#page-right,#page-single').innerHeight()||0,
		hh1 = jQuery('#page-head').innerHeight()||0,
		hh2 = jQuery('#page-menu-1').innerHeight()||0;
	return clip( mh + Math.max(hh1,hh2)/2, 180, 3600 );
}

export function dialogDynWidthFn( min, max ) {
	if( typeof min === 'undefined' || min==='auto' ) {
		return function(win_size) {
			return 'auto';
		};
	}
	return function(win_size) {
		return clip( getPreferedMaxDialogWidth()-40, min, max );
	};
}

export function dialogDynHeightFn( min, max ) {
	if( typeof min === 'undefined' || min==='auto' ) {
		return function(win_size) {
			return 'auto';
		};
	}
	return function(win_size) {
		return clip( getPreferedMaxDialogHeight()+0, min, max );
	};
}

export function closeDialog( elem, destroy, initiating_evt ) {
	if( initiating_evt && initiating_evt.type==='keydown' && initiating_evt.which===27 ) {
		if( window.MVPageDebug && window.MVPageDebug.isVisible() ) {
			// dont close dialog! but allow #dprint code to handle the keydown event ...
			return false;
		}
	}
	// jquery ui would throw error when trying to call close() on element that is not (or no longer) a dialog widget
	if( elem!==null ) {
		for( var i=0; i<elem.length; ++i ) {
			var ie = elem[i];
			if( jQuery.data(ie,'ui-dialog') ) jQuery(ie).dialog( destroy ? 'destroy' : 'close' );
			else if( jQuery.data(ie,'jqueryUiExtendeddialog') ) jQuery(ie).extendeddialog( destroy ? 'destroy' : 'close' );
		}
	}
	return true;
}



export function scrollElementIntoView( elm, cnt, missing_offset, snap_to_top_px_range ) {
	if( !elm || !elm.length ) return;
	var mo = missing_offset ? missing_offset : 0;
	var elmT = elm[0].offsetTop + mo,
		elmB = elmT + parseInt(elm.height()||0,10),
		cntT = cnt.scrollTop(),
		cntH = parseInt(cnt.height()||0,10),
		cntB = cntT + cntH,
		s = null,
		i, e, t, b;
	for( i=1; i<elm.length; ++i ) {
		e = elm[i];
		t = e.offsetTop + mo - 1;
		if( t<elmT ) elmT = t;
		b = t + (jQuery(e).height()||0) + 2;
		if( b>elmB ) elmB = b;
	}
	if( elmB<cntT ) {
		s = elmT;
	} else if( elmT<cntT && elmB>=cntT && elmB<cntB ) {
		s = elmT;
	} else if( elmT>=cntT && elmB>=cntT && elmB<cntB ) {
		/* no-op */
	} else if( elmT>=cntT && elmT<cntB && elmB>=cntB ) {
		s = elmB-cntH+1;
		if( elmT<s && elmB>=s ) s = elmT;
	} else if( elmT>=cntT && elmT>=cntB && elmB>=cntB ) {
		s = elmB-cntH+1;
		if( elmT<s && elmB>=s ) s = elmT;
	} else if( elmT<cntT && elmB>=cntB ) {
		/* no-op */
	}
	if( s!==null ) {
		if( snap_to_top_px_range && s<=snap_to_top_px_range ) s = 0; // snap to top
		cnt.scrollTop(s);
	}
}



export function focusFirstElement( container, tabbable_only, exclude_hidden_inputs, exclude_buttons, use_autofocus, focus_last_element ) {
	var tmp, candidates;
	if( use_autofocus && (tmp=container.find('[autofocus]')).length ) candidates = tmp;
	else candidates = container.find(':input,span.string-label').filter(':visible:'+(tabbable_only?'tabbable':'focusable'));
	if( exclude_hidden_inputs ) candidates = candidates.not('[type="hidden"]');
	if( exclude_buttons ) candidates = candidates.not(':button');
	var first = candidates.eq(focus_last_element?-1:0);
	if( first.length ) {
		if( first[0].nodeName==='INPUT' && first.attr('type')==='radio' ) {
			if( (tmp=first.siblings(':checked')).length ) first = tmp.eq(focus_last_element?-1:0);
		}
		return first.trigger('focus');
	}
	return null;
}


